import { useAtom } from 'jotai';
import useMatomo from '@hooks/useMatomo';
import { cookieBannerAcceptedAtom } from '@/global-store';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogDescription,
  DialogTitle,
  Link,
  ToggleWithLabel,
} from '@eye-able/ui';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';
import { T } from '@/i18n/T';

const PrivacyDialog = () => {
  const { t } = useInlineTranslation();
  const { matomoOptIn, setMatomoOptIn, enableMatomoTracking } = useMatomo();
  const [accepted, setAccepted] = useAtom(cookieBannerAcceptedAtom);

  const handleConfirm = () => {
    setAccepted(true);

    if (matomoOptIn) {
      enableMatomoTracking();
    }
  };

  return (
    <Dialog open={!accepted}>
      <DialogContent persistent>
        <DialogTitle className='eye:sr-only'>
          <T k='privacyDialogTitle' />
        </DialogTitle>
        <DialogDescription>
          <div className='eye:flex eye:flex-col eye:gap-2xs'>
            <p>
              <T k='privacyDialogDesc' />
            </p>
            <p>
              <T k='privacyDialogMore' />{' '}
              <Link href='/privacy-policy' target='_blank' size='small'>
                {t('privacyPolicy')}
              </Link>
              .
            </p>
            <ToggleWithLabel
              checked={matomoOptIn !== false}
              label={t('enableAnalytics')}
              onCheckedChange={setMatomoOptIn}
            />
          </div>
        </DialogDescription>
        <DialogActions>
          <Button variant='yellow' onClick={handleConfirm}>
            {t('accept')}
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default PrivacyDialog;
